// TalentOS careers portal and the India candidate registration page (owner, 2026-09-28). These URLs come from the TalentOS tenant
// configuration for Visionary Staffing Solutions LLP (market IN, INR) — the registration page reports its own address as
// registration_url and its legal links as legal_links, so nothing here is a hand-built path. The registration page is the ONE
// candidate form: this site must never grow a second one.
export const CAREERS = {
  portal: "https://careers.visionarystaffingsolutions.in",
  register: "https://careers.visionarystaffingsolutions.in/talent/visionary-staffing/register",
  privacy: "https://careers.visionarystaffingsolutions.in/privacy",
  terms: "https://careers.visionarystaffingsolutions.in/terms",
  candidatePrivacy: "https://careers.visionarystaffingsolutions.in/candidate-privacy",
};

export const NAV_LINKS = [
  { id: "ecosystem", label: "Our Reach" },
  { id: "services", label: "Services" },
  { id: "industries", label: "Industries" },
  { id: "technology", label: "Stack" },
  { id: "process", label: "Manifesto" },
  { id: "about", label: "About" },
  // external: the careers portal is its own site, so this one is a link, not an in-page scroll target
  { id: "careers", label: "Careers", href: CAREERS.portal },
];

export const STATS = [
  { value: 500, suffix: "+", label: "Successful Placements", note: "executed across India in five years" },
  { value: 125, suffix: "+", label: "Enterprise Clients", note: "public & private sector partners" },
  { value: 340, suffix: "%", label: "Operational Growth", note: "year-over-year momentum" },
  { value: 100, suffix: "+", label: "Recruiters", note: "across Pune & Vadodara" },
];

export const SERVICES = [
  {
    idx: "01",
    title: "Contingent Staffing",
    body: "Rapid surge capacity with pre-vetted specialists deployed on demand for critical roadmap defense.",
  },
  {
    idx: "02",
    title: "SOW Engagements",
    body: "End-to-end outcome-based delivery with clear milestones, KPIs, and executive governance.",
  },
  {
    idx: "03",
    title: "Contract-to-Hire",
    body: "Zero-risk trial. Evaluate engineering fit in production before converting to full-time.",
  },
  {
    idx: "04",
    title: "Dedicated Pods",
    body: "Long-running engineering squads embedded with your product organisation and rituals.",
  },
  {
    idx: "05",
    title: "Hire-Train-Deploy",
    body: "Custom bootcamps that funnel curated talent through your stack and land production-ready.",
  },
];

export const INDUSTRIES = [
  {
    tag: "BFSI",
    title: "Banking & Financial Services",
    body: "High-rigor, compliance-focused technical and analytical talent for complex financial institutions and secure digital banking environments.",
  },
  {
    tag: "Healthcare",
    title: "Healthcare & Life Sciences",
    body: "Vetted clinical research professionals, scientific consultants, and secure healthcare administration experts aligned with strict patient-safety guidelines.",
  },
  {
    tag: "Enterprise IT",
    title: "Information Technology",
    body: "The core engine — advanced engineering, cloud platforms, custom software development, DevOps automation, and specialised IT implementations.",
  },
  {
    tag: "Operations",
    title: "Administrative & Clerical",
    body: "Essential operational talent, billing specialists, document controllers, and administrative personnel to keep enterprises humming.",
  },
];

export const TECH_GROUPS = [
  {
    title: "Cloud & DevOps",
    items: ["AWS", "Azure", "Docker", "Kubernetes", "CI/CD", "Terraform"],
  },
  {
    title: "Software Engineering",
    items: ["Java / Spring Boot", ".NET Core", "React", "Angular", "Vue.js", "Node.js", "Flutter", "iOS / Android"],
  },
  {
    title: "Data Science & AI",
    items: ["Python", "SQL", "Power BI", "ML Ops", "Predictive Analytics", "LLM Integrations"],
  },
  {
    title: "Quality & Architecture",
    items: ["Automated QA", "Regression Models", "Performance", "Agile", "Microservices", "ERP / SAP"],
  },
];

export const WHY_ITEMS = [
  {
    idx: "01",
    title: "Pre-Screened Experts",
    body: "Every specialist is strictly assessed for technical competence, real-world project readiness, and professional communication before introduction.",
  },
  {
    idx: "02",
    title: "Technical Validation",
    body: "Objectively test coding skills, design capability, and enterprise architecture via standardised technical filters and executive vetting panels.",
  },
  {
    idx: "03",
    title: "Flexible Engagement",
    body: "Scale up or down with Contingent, SOW, Contract-to-Hire, Dedicated Teams, and Hire-Train-Deploy pipelines.",
  },
  {
    idx: "04",
    title: "24-48hr Submissions",
    body: "Receive deeply curated and technically validated profiles within 24 to 48 hours for immediate project execution.",
  },
];

export const PROCESS_STEPS = [
  {
    idx: "01",
    title: "Understand",
    body: "We map your technology requirements, project timelines, domain criteria, and preferred engagement models in a working session with your leadership.",
  },
  {
    idx: "02",
    title: "Curate & Screen",
    body: "Our recruitment engines identify, technically pre-validate, and double-review matches, sharing curated profiles in 24 to 48 hours.",
  },
  {
    idx: "03",
    title: "Select",
    body: "You evaluate pre-assessed candidates and select the perfect fit for team chemistry, tech parameters, and long-term outcomes.",
  },
  {
    idx: "04",
    title: "Deploy & Deliver",
    body: "Vetted resources onboard quickly, start execution immediately, defend delivery timelines, and build enterprise resilience.",
  },
];

export const SERVICE_OPTIONS = [
  "Contingent Staffing",
  "SOW Engagement",
  "Contract-to-Hire",
  "Dedicated Team / Pod",
  "Hire-Train-Deploy",
  "Advisory / Other",
];

export const CONTACT = {
  general: "info@visionarystaffingsolutions.in",
  pune: {
    person: "Girish Sahane",
    lines: [
      "1011, 10th Floor, Bramhacorp Business Park,",
      "New Kalyani Nagar, Pune – 411014",
      "India",
    ],
    phone: "+91 7757990401",
    email: "girish.sahane@visionarystaffingsolutions.in",
  },
  vadodara: {
    person: "Vikram Mahanta",
    lines: [
      "Felix Complex, 206, Kunal Char Rasta,",
      "Behind Iscon Heights, Gotri,",
      "Vadodara – 390021, Gujarat, India",
    ],
    phone: "+91 85112 17515",
    email: "vik@allitsolutions.us",
  },
};
